import { Box } from '@mui/material';
import { ReactElement, ReactNode, useEffect, useState } from 'react';
import {
  FIELD_COLUMN_MAX_WIDTH,
  FIELD_GRID_TWO_COLUMN_MIN_WIDTH,
} from 'src/components/SidePanelTabs/SiteDocumentation/site-documentation.constants';
import useResizeObserver from 'use-resize-observer';

interface ResponsiveFieldGridProps {
  children: ReactNode;
  minWidthForTwoColumns?: number;
}

export const ResponsiveFieldGrid = ({
  children,
  minWidthForTwoColumns = FIELD_GRID_TWO_COLUMN_MIN_WIDTH,
}: ResponsiveFieldGridProps): ReactElement => {
  const { ref: gridRef, width } = useResizeObserver<HTMLDivElement>();
  const [isTwoColumnLayout, setIsTwoColumnLayout] = useState(false);

  useEffect(() => {
    if (typeof width === 'number') {
      setIsTwoColumnLayout(width >= minWidthForTwoColumns);
    }
  }, [width, minWidthForTwoColumns]);

  const childStyles = isTwoColumnLayout
    ? {
        maxWidth: { xs: '100%', md: `${FIELD_COLUMN_MAX_WIDTH}px` },
        width: '100%',
        justifySelf: 'flex-start',
      }
    : {
        maxWidth: '100%',
        width: '100%',
        justifySelf: 'stretch',
      };

  return (
    <Box
      ref={gridRef}
      sx={{
        display: 'grid',
        gap: 1,
        gridTemplateColumns: isTwoColumnLayout ? 'repeat(2, minmax(0, 1fr))' : '1fr',
        px: 0,
        '& > *': childStyles,
      }}
    >
      {children}
    </Box>
  );
};
